export const GET_COURSE_COMPONENTS = "GET_COURSE_COMPONENTS"
export const GET_COURSE_COMPONENTS_FAIL = "GET_COURSE_COMPONENTS_FAIL"
export const GET_COURSE_COMPONENTS_SUCCESS = "GET_COURSE_COMPONENTS_SUCCESS"

export const ADD_NEW_COURSE_COMPONENT = "ADD_NEW_COURSE_COMPONENT"
export const ADD_COURSE_COMPONENT_SUCCESS = "ADD_COURSE_COMPONENT_SUCCESS"
export const ADD_COURSE_COMPONENT_FAIL = "ADD_COURSE_COMPONENT_FAIL"

export const UPDATE_COURSE_COMPONENT = "UPDATE_COURSE_COMPONENT"
export const UPDATE_COURSE_COMPONENT_SUCCESS = "UPDATE_COURSE_COMPONENT_SUCCESS"
export const UPDATE_COURSE_COMPONENT_FAIL = "UPDATE_COURSE_COMPONENT_FAIL"

export const DELETE_COURSE_COMPONENT = "DELETE_COURSE_COMPONENT"
export const DELETE_COURSE_COMPONENT_SUCCESS = "DELETE_COURSE_COMPONENT_SUCCESS"
export const DELETE_COURSE_COMPONENT_FAIL = "DELETE_COURSE_COMPONENT_FAIL"





